import moment from 'moment';
import React, { Component } from 'react';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';

import GoKids from '../../services/GoKids';

import PageTitle from '../../components/PageTitle';
import DataFetchPage from '../../components/DataFetchPage';

const CellCep = ({original}) => (
  <React.Fragment>
    <p>  <a target="_blank" href={`https://www.google.com/maps?q=${original.zipcode}`}>
        {original.zipcode}
      </a></p>
  </React.Fragment>
);

const columns = [
  {
    accessor: 'isRead',
    Cell: ({ value }) => (value ? null : <span style={styles.dot} />),
    width: 55
  },
  {
    Header: 'Nome',
    accessor: 'name',
    Cell: ({ value, original }) => (
      <React.Fragment>
        <h4>{value}</h4>
        <p>
          {original.email} · {original.phoneNumber}
        </p>
      </React.Fragment>
    )
  },
 
  {
    Header: 'CEP',
    accessor: 'zipcode',
    className: 'text-center',
    Cell: CellCep,
  },
  {
    Header: 'Cidade',
    id: 'location',
    accessor: ({ city, state }) => (city ? `${city || '?????'}/${state || '??'}` : '-'),
    className: 'text-center'
  },
  {
    Header: 'Solicitado em',
    className: 'text-center',
    accessor: 'createdAt',
    Cell: ({ value }) => moment(value).format('L LT')
  },
  {
    width: 140,
    className: 'cell-actions',
    filterable: false,
    sortable: false,
    Cell: ({ original }) => (
      <Button size="sm" target="_blank" color="link" href={`/familias/solicitacoes/${original._id}/info`}>
        mais informações
      </Button>
    )
  }
];

class FamilyRequestList extends Component {
  render() {
    return (
      <React.Fragment>
        <PageTitle title="Solicitação de orçamento" />
        <DataFetchPage
          className="card card-table"
          fetch={GoKids.listFamilyRequests}
          renderToolbar={this.renderTopActions}
          renderContent={this.renderContent}
        />
      </React.Fragment>
    );
  }

  renderTopActions = ({ isLoading, data }) => (
    <div className="card-top-actions">
      <h4>({isLoading ? '...' : data.length}) solicitações de orçamento</h4>
      <Button tag={Link} to="/familias" color="link">
        Ver famílias
      </Button>
    </div>
  );

  renderContent = ({ isLoading, data }) => (
    <ReactTable loading={isLoading} data={data || []} columns={columns} />
  );
}

const styles = {
  dot: {
    display: 'inline-block',
    width: 12,
    height: 12,
    backgroundColor: '#007bff',
    borderRadius: 6,
    margin: 8
  }
};

export default FamilyRequestList;



// WEBPACK FOOTER //
// ./src/screens/family/FamilyRequestList.js